import React from 'react'
import { LandingPageImport } from '../Import'
const { BadgeCheck, Clock4, GitCommitHorizontal, MapPin, TextAnimate, ImageAnimate, about_img1, about_img2, about_img3 } = LandingPageImport

export default function AboutArea() {
    return (
        <>
            <div className="about_area padding-100">
                <div className="container">
                    <div className="row g-0 align-items-center">
                        <div className="col-lg-3">
                            <div className='hero_img'>
                                <ImageAnimate src={about_img1} alt="img" />
                            </div>

                            <div className="content_box mt-2">
                                <p>Upcoming Event 2025</p>

                                <h6>Digital Technology's</h6>

                                <div className='about_location'>
                                    <p>
                                        <Clock4 size={20} /> 10.00 AM -12.00 PM
                                    </p>
                                    <p>
                                        <MapPin size={20} /> 26/C Vijay Nagar, Indore
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3">
                            <div className='hero_img mt-4'>
                                <ImageAnimate src={about_img2} alt="img" />
                            </div>
                            <div className='hero_img mt-2'>
                                <ImageAnimate src={about_img3} alt="img" />
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className='hero_title'>
                                <h5 data-aos="fade-left" data-aos-duration="800">
                                    <GitCommitHorizontal className='ms-1 me-1' />
                                    ABOUT OUR BUSINESS CONFERENCES
                                </h5>
                            </div>

                            <div className="hero_sub_title">

                                <h2>
                                    <TextAnimate text="Innovating for Tomorrow Insights for Business" />
                                </h2>

                                <p data-aos="fade-left" data-aos-duration="900">
                                    Perfectly captures the essence of what this blog aims to deliver. In a rapidly evolving business landscape, leaders must stay.
                                </p>

                                <ul className='about_list' data-aos="fade-left" data-aos-duration="1000">
                                    <li><span><BadgeCheck className='mb-1' /></span> Director of the Developing Communities</li>
                                    <li><span><BadgeCheck className='mb-1' /></span> Deputy Attorney General Media Project</li>
                                    <li><span><BadgeCheck className='mb-1' /></span> Law School and Civil Rights Attorney</li>
                                    <li><span><BadgeCheck className='mb-1' /></span> Majored in Political Science</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
